import React from 'react';
import 'katex/dist/katex.min.css';
import {
  containsMathContent,
  renderMathContentToHtml,
  renderRawMathExpressionToHtml
} from '../utils/mathContent';

export default function MathContent({ text = '', className = '', style = {}, as = 'span' }) {
  const Element = as;
  const value = String(text ?? '');
  if (!containsMathContent(value)) return <Element className={className} style={style}>{value}</Element>;
  return (
    <Element
      className={`assessnow-math-content ${className}`.trim()}
      style={style}
      dangerouslySetInnerHTML={{ __html: renderMathContentToHtml(value) }}
    />
  );
}

export function MathExpression({ value = '', displayMode = false, className = '', style = {} }) {
  if (!String(value ?? '').trim()) return null;
  return (
    <span
      className={`assessnow-math-expression ${className}`.trim()}
      style={style}
      dangerouslySetInnerHTML={{ __html: renderRawMathExpressionToHtml(value, { displayMode }) }}
    />
  );
}

